import React from 'react';
import { Col, Row } from 'reactstrap';
import { LinkComponent } from '../Helpers';
import * as Constants from '../../../Constants/Constants';
import { SUBTITLE_LINK_INLINE } from '../../../Constants/Constants';

const DurationComponent = ({ startDate, endDate, styles, datePosition, paddingBottom }) => {
	// //console.log("Date Styles", styles);
	return datePosition !== Constants.DATE_IN_ROW ? (
		// , paddingBottom: paddingBottom || '0.5rem'
		<div style={{...styles, whiteSpace: 'nowrap'} || null}>
			{startDate} {startDate ? " - " : null} {endDate}
		</div>
	) : (
		<div style={{position: 'relative',paddingBottom: '1rem'}}>
			<div style={{...styles, position: 'absolute', top: '-0.4rem', left: '-0.5rem', whiteSpace: 'nowrap', paddingBottom: '0.5rem'} || null}>
				{startDate} {startDate ? " - " : null} {endDate}
			</div>
		</div>
	);
};

const TitleComponent = ({ title, styles }) => {
	// //console.log("Title Styles", styles);
	return (
		<div style={styles || null}>
			{title}
		</div>
	);
};

const SubTitleComponent = ({ subTitle, styles, isSubtitleLink, link_url }) => {
	// //console.log("Subtitle Styles", styles);
	return isSubtitleLink ? (
		<LinkComponent 
			print
			link={link_url}
			// icon={'fa fa-external-link'} 
			anchor={subTitle}
			styles={!styles ? null : styles || null} />
	) : (
		<div style={styles || null}>
			{subTitle}
		</div>
	);
};


const DescriptionComponent = ({ description, styles }) => {
	// //console.log("Description Styles", styles);
	// const description = 
	return description.length === 1 ? (
		<div key="description" style={styles || null}>{description[0]}</div>
	) : (description.length && (
			<ul key="description" style={styles || null}>
				{description.map((item, index) => <li key={index}>{item}</li>)}
			</ul>
		)) || null;
	// description = description ? description.split("\n") : [];
	// return (
	// 	<div style={styles || null}>
	// 		{description.map((item, index) => <div key={index}>{item}</div>)}
	// 	</div>
	// );
};


export const ExperienceItemComponent = ({ showTimeline, styles, data, dateFormat, datePosition, linkStyles, showDescription, paddingBottom, linkPosition, linkAlign, timelineLight, isLastItem, isFirstItem, isSubtitleLink }) => {

	let node = null;

	const description = showDescription ?
		<DescriptionComponent description={data.description}
			styles={!styles ? null : styles.section.item.description || null} /> : null;

	const title = <TitleComponent title={data.title} styles={!styles ? null : styles.section.item.title || null} />;

	const subtitle = data.subTitle ?
		<SubTitleComponent 
			subTitle={data.subTitle}
			isSubtitleLink={data.link_url && isSubtitleLink}
			link_url={data.link_url}
			styles={!styles ? null : {...linkStyles, ...styles.section.item.subTitle} || null} 
		/> : null;

		const experienceLink = (data.link_url && !isSubtitleLink) ?
		<LinkComponent link={data.link_url} icon={!data.link_title && 'fa fa-link'} anchor={data.link_title && "(" + (data.link_title || "Link") + ")"}
			styles={!styles ? null : linkStyles || null} /> : null
	
		const duration = <DurationComponent 
			datePosition = {datePosition}
			startDate={dateFormat === Constants.START_TO_END ? data.startDate : null} 
			endDate={data.endDate}
		styles={!styles ? null : styles.section.item.duration || null} />;

	let subtitle_link_description_node = (
		<div>
			{subtitle}
			{description}
			{experienceLink}
		</div>
	);
	if (linkPosition === SUBTITLE_LINK_INLINE) {
		subtitle_link_description_node = (
			<div>
				<div className={`d-flex flex-row ${linkAlign === 'left'? "" : "justify-content-between"}`}>
					<div className="">
						{subtitle}
					</div>
					{/* <div className={linkAlign == 'left' ? "" :"text-right"}> */}
					<div className="ml-2 d-flex justify-content-center align-items-center">
						{experienceLink}
					</div>
				</div>
				{description}
			</div>
		)
	}
	


	switch (datePosition) {
		case Constants.NO_DATE:
			node = (
				<Row style={{ paddingBottom: { paddingBottom } }}>
					<Col style={{ display: 'flex', flexDirection: 'column' }}>
						{title}
						{subtitle_link_description_node}
					</Col>
				</Row>
			);
			break;
		case Constants.DATE_INLINE:
			node = (
				<Row style={{ paddingBottom: { paddingBottom } }}>
					<Col style={{ display: 'flex', flexDirection: 'column' }}>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
							<div>{title}</div>
							<div>{duration}</div>
						</div>
						{subtitle_link_description_node}
					</Col>
				</Row>
			);
			break;
		case Constants.DATE_IN_COLUMN:
			node = (
				<Row style={{ paddingBottom: { paddingBottom } }}>
					<Col xs={2} style={{ padding: "0", margin: "0", marginLeft: "1rem" }} className="no-gutters">
						{duration}
					</Col>
					<Col style={{ display: 'flex', flexDirection: 'column' }} className="no-gutters">
						{title}
						{subtitle_link_description_node}
					</Col>
				</Row>
			);
			break;
		//case Constants.DATE_IN_ROW:
		default:
			node = (
				<Row style={{ paddingBottom: { paddingBottom } }}>
					<Col style={{ display: 'flex', flexDirection: 'column' }}>
						{duration}
						{title}
						{subtitle_link_description_node}
					</Col>
				</Row>
			);
			break;
	}
	let topBallBackground = 'Transparent', bottomBallBackground='Transparent', timelineColor='Transparent';
	let topBallBorderColor = topBallBackground;
	if(showTimeline){
		topBallBackground = (timelineLight && styles.section.timelineLight.topBallColor) 
				|| styles.section.timelineDark.topBallColor 
				|| 'Transparent';
				// || 'rgba(255,238,88, 1.0)';
		bottomBallBackground = (timelineLight && styles.section.timelineLight.bottomBallColor)
				|| styles.section.timelineDark.bottomBallColor 
				|| 'Transparent';
				// || 'grey';
		timelineColor = (timelineLight && styles.section.timelineLight.color)
			|| styles.section.timelineDark.color 
			|| 'Transparent';							
			// || 'rgba(0, 0, 0, 0.6)';
		topBallBorderColor = (timelineLight && styles.section.timelineLight.topBallBorderColor) 
			|| styles.section.timelineDark.topBallBorderColor 
			|| topBallBackground;

	}
	return (
		<div
			className="section-item" 
			style={!styles ? null : {
				...styles.section.item, 
				position: 'relative', 
				padding: showTimeline ? '1rem 0rem 1rem 1.25rem' : '1rem 0rem 0.75rem 0',
				paddingTop: isFirstItem ? '0' : '0',
				borderLeft: `2px solid ${timelineColor}`
			}}>
			{node}
			
			<div style={{
				boxSizing: 'content-box',
				zIndex: '1',
				position: 'absolute', 
				top: "0rem", 
				// left: "-0.5rem", 
				left: "-0.4rem",
				background: topBallBackground,
				borderWidth: '0.1rem',
				// borderStyle:'outset',
				borderStyle: 'solid',
				borderColor: topBallBorderColor,
				// borderRadius: '50%', 
				transform: 'rotate(45deg)',
				height: "0.5rem", //'1rem', 
				width: '0.5rem'
			}}></div>
			{
				isLastItem && <div style={{
					position: 'absolute', 
					bottom: "0rem", 
					left: "-0.3rem", 
					background: bottomBallBackground,
					// borderRadius: '50%', 
					transform: 'rotate(45deg)',
					height: '0.5rem', 
					width: '0.5rem'
				}}></div>
			}

		</div>
	);
};

const Section = ({ title, data, showTimeline, styles, datePosition, dateFormat, showDescription, linkStyles, icon, linkPosition, linkAlign, timelineLight, isSubtitleLink }) => {
	return (
		<div className="section" style={!styles ? null : styles.section}>
			<h3 style={{ 
				...styles.section.title, 
				paddingBottom: '0.25rem',
				marginBottom: '0.25rem',
				// borderBottom: "1px solid #aaa" 
			}}>
				{title}<span className={icon} style={{ padding: "0.2rem" }}></span>
			</h3>
			<div style={{padding: showTimeline ? "0.5rem 0rem 1.25rem 1rem" : "0rem 0rem 1.25rem 0rem"}}>
				{data.map((item, index, arr) => <ExperienceItemComponent 
					styles={styles || null} 
					data={item} 
					key={index}
					showTimeline={showTimeline}
					datePosition={datePosition}
					dateFormat={dateFormat} showDescription={showDescription}
					linkStyles={linkStyles}
					linkPosition={linkPosition}
					linkAlign={linkAlign}
					timelineLight={timelineLight}
					isLastItem={arr.length-1 === index}
					isFirstItem={index === 0}
					isSubtitleLink={isSubtitleLink}
				/>)}
			</div>
		</div>
	);
};

export default Section;